import React from "react";

const Wheat = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Wheat</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className=" table table-striped table-bordered ">
          <thead className="text-center">
            <tr >
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>C-306 (Desi) [Released in 24.09.1969]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>25th October to Ist week of November</td>
              <td>4-5</td>
              <td>Medium late 140-150 days</td>
              <td>
                Hard &amp; Bold grains, suitable for infertile, not irrigated as
                well irrigated land. Resistant to rust.
              </td>
              <td>10 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-147 [Released in 19.12.1978]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Up to 3rd week of November</td>
              <td>4-5</td>
              <td>Almost 140 days</td>
              <td>
                Soft &amp; medium size grain. Suitable for medium fertile, not
                irrigated &amp; less irrigated areas. Resistant to loose smut
                and yellow rust.
              </td>
              <td>20 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-283 [Released in 09.04.1985]</strong>
              </td>
            </tr>
            <tr>
              <td>40-50 kgs per acre</td>
              <td>Up to 3rd week of November</td>
              <td>4-5</td>
              <td>Medium early almost 130-135 days</td>
              <td>
                Hard, Bold, Amber colour &amp; Lustrous grain. Suitable for
                fertile &amp; irrigated areas. Dwarf variety, resistant to
                yellow and brown rust and partially resistant to Karnal bunt.
              </td>
              <td>20 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-1021 [Released in 08.05.2008]</strong>
              </td>
            </tr>
            <tr>
              <td>40-45 kgs per acre</td>
              <td>Suitable for late sowing</td>
              <td>4-5</td>
              <td>121 days</td>
              <td>
                Hard &amp; Amber colour grain. Plant height 94cm. Lodging &amp;
                high temperature resistant. Gives good results in alkine &amp;
                saline soil. Resistant to yellow &amp; brown rust. 12.21%
                protein.
              </td>
              <td>17 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-542 [Released in 04.11.1992]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Suitable for timely sowing</td>
              <td>4-5</td>
              <td>Medium early 130 days</td>
              <td>
                Suitable for fertile &amp; irrigated areas. Dwarf variety, more
                spreading. Hard stem, waxy earheads. Resistant to rust &amp;
                semi resistant to Karnal bunt.
              </td>
              <td>22-23 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-711 [Released in 04.09.2002]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Suitable for timely sowing</td>
              <td>5-6</td>
              <td>145 days</td>
              <td>
                Suitable for entire Haryana State. Dwarf variety plant height
                81cm, grain medium length suitable for highly fertile &amp;
                irrigated areas. Resistant to disease. Spready &amp; lodging
                variety. Highly resistant to Karnal bunt. Gives good result in
                saline and alkaline soil.
              </td>
              <td>23-24 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PBW-502 [Released in 04.02.2004]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Suitable for early sowing</td>
              <td>5-6</td>
              <td>150 days</td>
              <td>
                Dwarf and spreading variety. Plant height 95cm. Dense earheads,
                bold, lustrous, hard and Amber colour grain. Resistant to Yellow
                and Brown rust. Less susptible to Karnal bunt and susptible to
                loose smut.
              </td>
              <td>20-21 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PBW-509 [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Suitable for late sowing</td>
              <td>4-5</td>
              <td>130 days</td>
              <td>
                Dwarf variety. Plant height 85cm. Medium dense earheads, dark
                green foliage. Lustrous &amp; Bold grains with Amber colour.
                Resistant to Yellow and Brown rust. Susptible to Karnal but 7
                loose smut.
              </td>
              <td>15-16 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PBW-343 [Released in 01.01.1996]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Suitable for timely sowing</td>
              <td>6-7</td>
              <td>155 days</td>
              <td>
                Amber colour grains suitable 7 fertile &amp; irrigated areas.
                Long duration variety. Resistant to Yellow &amp; Brown rust.
              </td>
              <td>23-24 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PBW-373 [Released in 09.09.1997]</strong>
              </td>
            </tr>
            <tr>
              <td>40 kgs per acre</td>
              <td>Late sowing. First fortnight of December</td>
              <td>5-6</td>
              <td>140 days</td>
              <td>
                Highly resistant to Yellow &amp; Brown rust. Bold, Amber, Hard
                and Lustrous grain. Lodging resistant.
              </td>
              <td>18 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>RAJ-3765 [Released in 01.01.1996]</strong>
              </td>
            </tr>
            <tr>
              <td>40-50 kgs per acre</td>
              <td>Suitable for late sowing</td>
              <td>4-5</td>
              <td>120 days</td>
              <td>
                Hard &amp; Amber colour grain. Lodging resistant, suitable for
                irrigated areas.
              </td>
              <td>18 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>UP-2328 [Released in 04.05.1995]</strong>
              </td>
            </tr>
            <tr>
              <td>40-50 kgs per acre</td>
              <td>Suitable for timely and late sowing</td>
              <td>4-5</td>
              <td>130-135</td>
              <td>
                Earheads white. Hard, Sarbati colour &amp; medium size grains.
                Suitable irrigated areas.
              </td>
              <td>20-22 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-1025 [Released in 29.01.2010]</strong>
              </td>
            </tr>
            <tr>
              <td>40-45 kgs per acre</td>
              <td>Suitable for early sowing</td>
              <td>5-6</td>
              <td>140-150 days</td>
              <td>This variety resembles &amp; good replacement of C-306.</td>
              <td>11-12 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>WH-912 [Released in 04.09.2002]</strong>
              </td>
            </tr>
            <tr>
              <td>40-50 kgs per acre</td>
              <td>Suitable for early sowing</td>
              <td>5-6</td>
              <td>146 days</td>
              <td>
                Durum variety. Used in Bakery Industry. Protein content 12%.
                Resistant Yellow &amp; Brown and rust as well as karnal bunt.
              </td>
              <td>19 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>DBW-17 [Released in 06.02.2007]</strong>
              </td>
            </tr>
            <tr>
              <td>40-45 kgs per acre</td>
              <td>Suitable for early sowing</td>
              <td>5-6</td>
              <td>140 days</td>
              <td>
                Yield of this variety is equal to check variety PBW-343.
                Suitable for timely sowing. Lodging resistant.
              </td>
              <td>23-24 quintals per acre</td>
            </tr>
          </tbody>
        </table>

      
      </div>
    </div>
  );
};

export default Wheat;
